<div t4-tooltip class="t4EntityLink">
    <span class="bookingText"><a href="javascript: void(0)" (mouseenter)="show()" (mouseleave)="hide()" (click)="open()"><span #ref><ng-content></ng-content></span><span *ngIf="ref.childNodes.length == 0">{{ bookingId }}</span></a></span>
    <div #tooltipContent class="t4Tooltip-container">
      <div class="t4Tooltip-content row" *ngIf="booking">
        <div class="col-xs-6">
          <label>{{ 'Turbo.Data.Booking.PickupTime' | translate : 'Pickup time'}}</label>
          <div>{{ booking.PickupTime | date : 'yyyy-MM-dd HH:mm' }}</div>
          <label>{{ 'Turbo.Data.Booking.ReturnTime' | translate : 'Return time'}}</label>
          <div>{{ booking.ReturnTime | date : 'yyyy-MM-dd HH:mm' }}</div>
          <label style="margin-top: 10px;">{{ 'Turbo.Data.Booking.CreatedAt' | translate : 'Created at'}}</label>
          <div>{{ booking.CreatedAt | date : 'yyyy-MM-dd HH:mm' }}</div>
          <label>{{ 'Turbo.Data.Booking.QueuedAt' | translate : 'Queued at'}}</label>
          <div>{{ booking.QueuedAt | date : 'yyyy-MM-dd HH:mm' }}</div>
        </div>
        <div class="col-xs-6">
          <label>{{ 'Turbo.Data.Booking.PickupLocation' | translate : 'Pickup location'}}</label>
          <div>{{ booking.PickupLocation?.Name || '-' }}</div>

          <label>{{ 'Turbo.Data.Booking.ReturnLocation' | translate : 'Return location'}}</label>
          <div>{{ booking.ReturnLocation?.Name || '-'}}</div>

          <label style="margin-top: 10px;">{{ 'Turbo.Data.Booking.Status' | translate : 'Status'}}</label>
          <div>{{ 'Turbo.Core.bookingTooltip.Status_' + booking.Status | translate }}</div>
          <label *ngIf="booking.IsWebRental">{{ 'Turbo.Data.Booking.IsWebBooking' | translate : 'Web booking'}}</label>
        </div>
        <button mat-icon-button (click)="sendSms()" *ngIf="Settings.isInAny(['OneWayAdmin'])">
          <mat-icon matTooltip="{{ 'Turbo.Common.Commands.SendSms' | translate : 'Send SMS'}}">chat</mat-icon>
        </button>
        <button mat-icon-button (click)="callCustomer()" *ngIf="Settings.isInAny(['OneWayAdmin'])">
          <mat-icon matTooltip="{{ 'Turbo.Common.Commands.Call' | translate : 'Call customer'}}">call</mat-icon>
        </button>
        <button mat-icon-button (click)="confirmBooking()" *ngIf="Settings.isInAny(['OneWayAdmin']) && booking.IsOneWay && booking.Status == 0">
          <mat-icon matTooltip="{{ 'Turbo.Common.Commands.Confirm' | translate : 'Confirm this booking'}}">done_outline</mat-icon>
        </button>
      </div>
      <!--<div class="t4Tooltip-contentLoader row" *ngIf="!booking">
      <mat-spinner indeterminate="true"></mat-spinner> 
  </div>-->
    </div>
</div>
